const originalBgColor = getComputedStyle(document.body).backgroundColor;
const originalTextColor = document.body.style.color;

let activeSection = null;

const rootMarginValue = "-33.33% 0px -33.33% 0px";

const observer = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      // セクションが交差範囲に入った場合
      activeSection = entry.target;
    } else if (activeSection === entry.target) {
      // セクションが交差範囲から出た場合
      activeSection = null;
    }
  });

  // アクティブなセクションがあれば色を更新、なければリセット
  if (activeSection) {
    updateColors(activeSection);
  } else {
    resetColors();
  }
}, { threshold: 0, rootMargin: rootMarginValue });

document.querySelectorAll('.js-change-bg').forEach(section => {
  observer.observe(section);
});

function updateColors(section) {
  const bgColor = section.dataset.bgColor || originalBgColor;
  const textColor = section.dataset.textColor || originalTextColor;
  document.body.style.backgroundColor = bgColor;
  document.body.style.color = textColor;
}

function resetColors() {
  document.body.style.backgroundColor = originalBgColor;
  document.body.style.color = originalTextColor;
}
